import { Rect } from "@react-pdf/renderer";
import Helper from "../functions/Helper.js";
import tinycolor from "tinycolor2";

function getSvgTransformProperty(angle, center) {
  const radians = (angle * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const x = center[0];
  const y = center[1];

  return `matrix(${cos}, ${sin}, ${-sin}, ${cos}, ${x - (cos * x - sin * y)}, ${
    y - (cos * y + sin * x)
  })`;
}

export default function PdfRectangle(props) {
  let { x, y, width, height } = Helper.convertRectToSVG(
    props.pos[0],
    props.pos[1],
    props.width,
    props.height,
    props.court.full
  );

  let angle = props.angle;
  let center = Helper.getCenter(x, y, width, height);

  let color = tinycolor(props.backgroundColor);
  let alpha = color.getAlpha();
  let hex = color.toHexString();

  return (
    <Rect
      x={x}
      y={y}
      width={width}
      height={height}
      fillOpacity={alpha}
      fill={hex}
      transform={getSvgTransformProperty(angle, center)}
      rx={0}
      ry={0}
    />
  );
}
